import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=899485e0&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/ul-list.css?vue&type=style&index=0&id=899485e0&prod&scoped=true&lang=css&external"
import style1 from "./VideoList.vue?vue&type=style&index=1&id=899485e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899485e0",
  null
  
)

export default component.exports